/* __next_internal_client_entry_do_not_use__ RenderBrandApplication auto */ import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx } from "react/jsx-runtime";
import { Route } from "@faire/web-api--source/Route";
import { props as brandApplicationRouteProps } from "@faire/web-api--source/routes/apply";
import React from "react";
import { MakerSignUpContextStoreProvider } from "@faire/retailer/views/apply/MakerApplication/MakerSignUpStore";
import { MakerSignUpFormContextStoreProvider } from "@faire/retailer/views/apply/MakerApplication/MakerSignUpFormStore";
import { BrandApplication } from "@faire/retailer/views/apply/MakerApplication";
export var RenderBrandApplication = function() {
    return /*#__PURE__*/ _jsx(MakerSignUpContextStoreProvider, {
        children: /*#__PURE__*/ _jsx(MakerSignUpFormContextStoreProvider, {
            children: /*#__PURE__*/ _jsx(Route, _object_spread_props(_object_spread({}, brandApplicationRouteProps), {
                component: BrandApplication
            }))
        })
    });
};
